import abayaIcon from '../assets/images/abaya-icon.svg';
import babiesIcon from '../assets/images/babies-icon.svg';
import beautyIcon from '../assets/images/beauty-icon.svg';
import bookingsIcon from '../assets/images/bookings-icon.svg';
import carsIcon from '../assets/images/cars-icon.svg';
import coffeeIcon from '../assets/images/coffee-icon.svg';
import deliveryIcon from '../assets/images/delivery-icon.svg';
import electronicsIcon from '../assets/images/electronics-icon.svg';
import fashionIcon from '../assets/images/fashion-icon.svg';
import flowersIcon from '../assets/images/flowers-icon.svg';
import furnitureIcon from '../assets/images/furniture-icon.svg';
import gamesIcon from '../assets/images/games-icon.svg';
import giftsIcon from '../assets/images/gifts-icon.svg';
import groceriesIcon from '../assets/images/groceries-icon.svg';
import healthIcon from '../assets/images/health-icon.svg';
import homeIcon from '../assets/images/home-icon.svg';
import jewelryIcon from '../assets/images/jewelry-icon.svg';
import oudIcon from '../assets/images/oud-icon.svg';
import perfumesIcon from '../assets/images/perfumes-icon.svg';
import petIcon from '../assets/images/pet-icon.svg';
import restaurantsIcon from '../assets/images/restaurants-icon.svg';
import servicesIcon from '../assets/images/services-icon.svg';
import shoesIcon from '../assets/images/shoes-icon.svg';
import sportsIcon from '../assets/images/sports-icon.svg';
import waterIcon from '../assets/images/water-icon.svg';

export const getCategoryIcon = (value) => {
  const icons = {
    abaya: abayaIcon,
    babies: babiesIcon,
    beauty: beautyIcon,
    bookings: bookingsIcon,
    cars: carsIcon,
    coffeeAndSweets: coffeeIcon,
    delivery: deliveryIcon,
    electronics: electronicsIcon,
    fashion: fashionIcon,
    flowers: flowersIcon,
    furniture: furnitureIcon,
    games: gamesIcon,
    gifts: giftsIcon,
    groceries: groceriesIcon,
    health: healthIcon,
    home: homeIcon,
    jewelry: jewelryIcon,
    oud: oudIcon,
    perfumes: perfumesIcon,
    pet: petIcon,
    restaurants: restaurantsIcon,
    services: servicesIcon,
    shoes: shoesIcon,
    sports: sportsIcon,
    water: waterIcon
  };
  
  return icons[value];
};